import { getUsersByIds } from './GetUsersByIds';
import { getChildOffices } from './GetChildOffices';

/**
 * Users API Client
 * Provides low-level HTTP calls to user endpoints
 */
export const UsersApi = {
  getUsersByIds,
  getChildOffices,
};
